import { Component } from '@angular/core';
import { OffcanvasBaseComponent } from '../../../../../shared/components/offcanvas/offcanvas-base/offcanvas-base.component';
import { OffcanvasHeaderBtnComponent } from '../../../../../shared/components/offcanvas/offcanvas-header-btn/offcanvas-header-btn.component';
import { EditEmployeeDetailsComponent } from '../../active-employees/edit-view/edit-employee-details.component';
import { InvitedEmployeeFormComponent } from '../form/invited-employee-form.component';

@Component({
  selector: 'app-edit-invited-employee',
  imports: [OffcanvasBaseComponent, OffcanvasHeaderBtnComponent, InvitedEmployeeFormComponent],
  templateUrl: './edit-invited-employee.component.html',
})
export class EditInvitedEmployeeComponent extends EditEmployeeDetailsComponent {
  protected override returnUrl: string = '/employee-invitations';
}
